import { timeline } from './../utility/timeline'
import scrollTo from './../utility/scrollTo'


const easeOutQuart = x => 1 - Math.pow(1 - x, 4)


function hasLoaded(els, callback) {

	if (els.length === 0) return callback()
		
	let loaded = 0
	function checkAll() {
		if (loaded === els.length) callback()
	}
	
	function setLoaded() {
		loaded++
		checkAll()
	}

	function checkImg(el) {
		if (el.complete) { 
			setLoaded()
		} else {
			el.addEventListener('load', () => {
				setLoaded()
			}, { once: true })
		}
	}

	function checkVideo(el) {
		if (el.readyState > 2) {
			setLoaded()
		} else {
			function handler(event) {
				if (event.currentTarget.readyState > 2)	{
					el.removeEventListener('readystatechange', handler)
					setLoaded()
				}
			}
			el.addEventListener('readystatechange', handler)
		}
	}

	els.map(el => {
		if (el.nodeName === 'IMG') checkImg(el)
		if (el.nodeName === 'VIDEO') checkVideo(el)
	})
}

function imageLoad(el, callback) {
	var placeholder = el.querySelector('.image-load__placeholder')
	var img = el.querySelector('.image-load__image')
	placeholder && img.addEventListener('transitionend', () => placeholder.remove(), { once: true })
	img.getBoundingClientRect()
	img.style.opacity = 1
	img.style.filter = 'blur(0px)'
}

function videoLoad(el) {
	el.classList.add('video-load--loaded')
}

export default function init() {

	const $ = x => document.querySelector(x)
	const hero = $('.js-hero')
	const video = $('.js-hero__video')
	const img = $('.js-hero__image')
	const background = $('.js-hero__background')
	const overlay = $('.js-hero__overlay')
	const title = $('.js-hero__title')
	const button = $('.js-hero__button')
	const anchor = $('.js-hero__anchor')
	const anchorLink = $('.js-hero__anchor__link')
	const siteHeaderInner = $('.js-site-header__inner')

	// load in elements visually once background video/image has loaded
		function onLoad() {
			if (video) videoLoad(video)
			if (img) imageLoad(img)
			if (overlay) imageLoad(overlay)
			if (background) background.classList.add('animate')

			setTimeout(() => {
				if (siteHeaderInner) siteHeaderInner.classList.add('animate')
				if (overlay) overlay.parentElement?.classList.add('animate')
			}, 250)

			setTimeout(() => {
				if (title) title.classList.add('animate')
			}, 500)	

			setTimeout(() => {
				if (button) button.classList.add('animate')
			}, 1000)

			setTimeout(() => {
				if (anchor) anchor.classList.add('animate')
			}, 1500)	
		}

		const loadEls = [video, img?.querySelector('img'), overlay?.querySelector('img')].filter(Boolean)
		hasLoaded(loadEls, onLoad)
	
	// scroll timeline
		let shown = true
		const heroContainer = $('.hero')
		const tl = timeline({
			start: () => heroContainer.offsetTop,
			end: () => heroContainer.offsetTop + heroContainer.offsetHeight
		})
		tl.onUpdate((pos, details) => {
			const eased = easeOutQuart(pos.percent).toFixed(5)
			const hideNav = pos.percentRaw > 0.9
			if (hideNav && shown) {
				siteHeaderInner.classList.add('hide')
				shown = false
			}
			if (!hideNav && !shown) {
				siteHeaderInner.classList.remove('hide')
				shown = true
			}
			document.body.style.setProperty('--hero-scroll-position', eased)
		})

	// anchor link click
	const scrollToEl = hero?.nextElementSibling
	anchorLink?.addEventListener('click', () => scrollTo(scrollToEl))
}

